import { useCallback } from "react";
import { useSelector } from "react-redux";

const useModuleName = ({ provider = "zoho_crm" } = {}) => {

  const schema = useSelector(state => {
    const company = state?.company || {};
    const map = {
      zoho_crm: company.zohoCrmModulesSchema,
    };
    return map[provider];
  });

  const getName = useCallback(
    (apiName, { plural = true, fallback = apiName } = {}) => {
      if (!schema || !apiName) return fallback;

      const rec = Array.isArray(schema)
        ? schema.find(r => r.api_name === apiName)
        : Object.values(schema).find(r => r?.api_name.toLowerCase().includes(apiName.toLowerCase()));

      if (!rec) return fallback;

      return plural ? rec.plural_label ?? fallback : rec.singular_label ?? fallback;
    },
    [schema]
  );

  return getName;
};

export default useModuleName;
